import React from 'react';

const SearchBar = ({ web3URL, setWeb3URL }) => {

  return (
    <div>
      <div class="shadow-lg mb-7 bg-white rounded" >
        <form class="input-group">
          <div class="input-group-append">
            <button type="button" class="btn btn-primary rounded-left">Enter Node URL</button>
          </div>
          <input
            type="search"
            class="form-control"
            placeholder="https://bsc-mainnet.web3api.com/v1/YOUR-API-KEY"
            onChange={(e) => setWeb3URL(e.target.value)}
            defaultValue={web3URL}
            autoFocus={true} />
        </form>
      </div>
    </div>
  );
};

export { SearchBar };
